module.exports = __webpack_public_path__ + "img/regulations-leisure-3.d3882383.jpg";